import { render, staticRenderFns } from "./swKeywords.vue?vue&type=template&id=4dd8fd4c&scoped=true"
import script from "./swKeywords.vue?vue&type=script&lang=js"
export * from "./swKeywords.vue?vue&type=script&lang=js"
import style0 from "./swKeywords.vue?vue&type=style&index=0&id=4dd8fd4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8fd4c",
  null
  
)

export default component.exports